import { translate } from '@/domains/core/localization/translate';
export const {
  showLess,
  showMore,
  knowMore
} = translate({
  "showLess": "Show less",
  "showMore": "Show more",
  "knowMore": "Know more"
});